import { referenceClient } from "@/lib/orpc/client";
import { getVisitScope, refreshVisitReads } from "@/lib/visit-queries";
import { useAuthStore } from "@/store/auth.store";

// The guided first visit's two writes, through the same API calls as the
// note editor and Settings > Profile, without their toasts.

// Saves the main note of a visit (the practice note with its flag), then
// reads the visit again. True when saved for the same account.
export const savePracticeNote = async (
  visitPublicId: string,
  result: string,
): Promise<boolean> => {
  const scope = getVisitScope();
  if (!scope) return false;
  try {
    await referenceClient.updateVisit(
      { params: { public_id: visitPublicId }, query: {}, body: { result } },
      { context: { expectedUserUid: scope.uid } },
    );
    if (getVisitScope() !== scope) return false;
    await refreshVisitReads(scope);
    return getVisitScope() === scope;
  } catch {
    return false;
  }
};

// Saves the specialty chosen on the welcome as the account's occupation.
export const saveOccupation = async (occupationId: number): Promise<void> => {
  const scope = getVisitScope();
  if (!scope) return;
  try {
    await referenceClient.updateMyPreferences(
      { query: {}, body: { occupationId } },
      { context: { expectedUserUid: scope.uid } },
    );
    if (getVisitScope() === scope) await useAuthStore.getState().getUser();
  } catch {
    // The welcome goes on; Settings > Profile can set it later.
  }
};
